import { FormControlLabel, Radio } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import React from 'react';

export default function RadioDyl({
    value = '',
    label = '',
    FormControlLabelProps = {},
    ...other
}) {
    return (
        <FormControlLabel
            value={value}
            label={label}
            control={(
                <Radio
                    color='primary'
                    checkedIcon={<CheckCircleIcon />}
                    {...other}
                />
            )}
            {...FormControlLabelProps}
        />
    );
}